/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Pattern_Disabled_NamedInputs */



/**
* | output |
* | --- |
* | "Pattern \"{name}\" is no longer monitoring requests" |
*
* @param {Audit_Details_Pattern_Disabled_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_disabled_named = /** @type {((inputs: Audit_Details_Pattern_Disabled_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Disabled_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Muster "${i?.name}" überwacht keine Anfragen mehr`)
	return /** @type {LocalizedString} */ (`Pattern "${i?.name}" is no longer monitoring requests`)
});